import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren, effect } from '@angular/core';
import { DoughnutChartData } from 'src/app/shared/components/doughnut-view/doughnut-chart-data.interface';
import {
  actionDots,
  suggDots,
  assignColors,
  huddleHighlights,
} from 'src/app/shared/constants/obj-constants';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var bootstrap: any;
import * as _ from 'lodash';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { NgIf, NgFor, NgStyle, NgClass, DecimalPipe } from '@angular/common';
import { LtmsDoughnutChartViewComponent } from '../../../../../shared/components/graph/ltms-doughnut-chart-view/ltms-doughnut-chart-view.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarComponent } from '../../../../../shared/components/progressBar/progress-bar/progress-bar.component';
import { ScoreTableComponent } from '../../../../../shared/components/score/score-table/score-table.component';
import { LtmsLoaderComponent } from '../../../../../shared/components/ltms-loader/ltms-loader.component';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-huddle-summary',
    templateUrl: './huddle-summary.component.html',
    styleUrls: ['./huddle-summary.component.scss'],
    imports: [
        NgIf,
        LtmsDoughnutChartViewComponent,
        NgFor,
        NgStyle,
        NgClass,
        NgbTooltip,
        ProgressBarComponent,
        ScoreTableComponent,
        LtmsLoaderComponent,
        DecimalPipe,
        TranslateModule,
    ]
})

export class HuddleSummaryComponent implements OnInit {
  tabType = {
    SUMMARY: 'summary',
    ALL_HUDDLES: 'all-huddles',
    ALL_ACTION_PLANS: 'all-action-plans',
    ALL_SUGGESTIONS: 'all-suggestions',
    ALL_SPOTLIGHTS: 'all-spotlights',
  };
  activeButton: string = 'left';

  @Input() errorCode: string = '404';
  @ViewChildren('commentText') commentTexts!: QueryList<ElementRef>;
  @ViewChildren('problemText') problemTexts!: QueryList<ElementRef>;
@ViewChildren('recommendationText') recommendationTexts!: QueryList<ElementRef>;
@ViewChildren('actionProblemText') actionProblemTexts!: QueryList<ElementRef>;
@ViewChildren('actionThemeText') actionThemeTexts!: QueryList<ElementRef>;
  doughnutIds: string[] = ['doughnutView1', 'doughnutView2'];
  doughnutLegendIds: string[] = ['legend-container-1', 'legend-container-2'];
  cards: any = [];
  loading: boolean = true;
  huddleBrandId: string | null = null;
  brandId: string | null = null;
  suggestionConfig: any = {};
  suggestionBrandId: string = '';
  actionConfig: any = {};
  actionBrandId: string = '';
  spotlightConfig: any = {};
  spotlightBrandId: string = '';
  totalMeeting: number = 0;
  brandDetails: any;
  huddleAccountId: string | null = null;
  actions: string | null = null;
  spotlights: string | null = null;
  escalations: string | null = null;
  spotlightData: any;
  actionPlanData: any;
  suggestionData: any;
  actionTotalFeeds!: number;
  suggTotalFeeds!: number;
  spotlightTotalFeeds!: number;
  totalHuddleFeeds: number = 0;
  huddleHighlights: any = huddleHighlights;
  actionDots = actionDots;
  suggDots = suggDots;
  hierarchyStack: any;
  selected_level: string = '';
  selected_value: any;
  startDate: any = '';
  endDate: any = '';
  isDropdownOpen: boolean[] = [];

  actionDonutData: any = [];
  actionDonutColors: string[] = [];
  suggDonutData: any = [];
  suggDonutColors: string[] = [];

  private levelSet: boolean = false;
  private optionsSet: boolean = false;
  columns = [
    [
      {
        header: 'Themes',
        dataKey: 'title',
        enabled: true,
        dataType: 'date',
        order: 1,
        uniqueId: 'title',
        width: '400px',
      },
      {
        header: 'Total',
        dataKey: 'unit',
        enabled: true,
        dataType: 'string',
        order: 2,
        uniqueId: 'unit',
        width: '150px',
      },
      {
        header: 'Closed',
        dataKey: 'Closed',
        enabled: true,
        dataType: 'string',
        style: {
          headerTextAlign: 'left',
          cellTextAlign: 'left',
          width: '20%',
        },
        order: 3,
        uniqueId: 'Closed',
        width: '150px',
      },
      {
        header: 'Open',
        dataKey: 'Open',
        enabled: true,
        dataType: 'string',
        style: {
          headerTextAlign: 'left',
          cellTextAlign: 'left',
          width: '20%',
        },
        order: 4,
        uniqueId: 'Open',
        width: '150px',
      },
    ],
    [
      {
        header: 'Themes',
        dataKey: 'title',
        uniqueId: 'title',
        enabled: true,
        dataType: 'date',
        order: 1,
        width: '400px',
      },
      {
        header: 'Assigned to Cluster Head',
        dataKey: 'unit',
        uniqueId: 'Assigned to Cluster Head',
        enabled: true,
        dataType: 'string',
        order: 2,
        width: '150px',
      },
      {
        header: 'Assign to Cluster Head',
        dataKey: 'unit',
        uniqueId: 'Assign to Cluster Head',
        enabled: true,
        dataType: 'string',
        order: 3,
        width: '150px',
      },
      {
        header: 'Assigned to Circle Head',
        dataKey: 'unit',
        uniqueId: 'Assigned to Circle Head',
        enabled: true,
        dataType: 'string',
        order: 4,
        width: '150px',
      },
      {
        header: 'Assigned to Zonal Head',
        dataKey: 'unit',
        uniqueId: 'Assigned to Zonal Head',
        enabled: true,
        dataType: 'string',
        order: 5,
        width: '150px',
      },
      {
        header: 'Assign to Circle Head',
        dataKey: 'unit',
        uniqueId: 'Assign to Circle Head',
        enabled: true,
        dataType: 'string',
        order: 6,
        width: '150px',
      },
    ],
  ];

  actionDonutChartData: DoughnutChartData = {
    header: '',
    names: [],
    data: [],
    color: [],
    // legendPosition: ''
  };

  colorMapping = {
    Closed: 'rgb(11, 113, 57)',
    Open: 'rgb(237, 36, 36)',
    'N/A': 'rgb(136, 136, 136)',
    'Assign to Cluster Head': 'rgb(187, 213, 49) ',
    'Assigned to Circle Head': ' rgb(245, 234, 20)',
    'Assigned to Cluster Head': 'rgb(102, 184, 70) ',
    'Assigned to Zonal Head': ' rgb(44, 123, 182)',
    'Assign to Circle Head': ' rgb(44, 123, 182)',
  };

  viewModes: string[] = [];
  huddleConfigurations = [
    {
      taskType: 'action',
      doughnutId: 'doughnutView1',
      legendId: this.doughnutLegendIds[0],
      cardIndex: 0,
    },
    {
      taskType: 'suggestions',
      doughnutId: 'doughnutView2',
      legendId: this.doughnutLegendIds[1],
      cardIndex: 1,
    },
  ];

  ngAfterViewInit(): void {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltip) => new bootstrap.Tooltip(tooltip));
    this.updateEllipsisStates();
    this.suggestionEllipsisStates()
    this.actionPlanEllipsisStates();
  }

  ngAfterViewChecked() {
    this.updateEllipsisStates(); // ensure updates after DOM is rendered
    this.suggestionEllipsisStates()
    this.actionPlanEllipsisStates();
  }

  constructor(
    private huddleService: HuddlesService,
    private helperSerice: HelpersService,
    private route: ActivatedRoute,
    private globalFilterService: GlobalFilterService,
    private _stateService: AppStateService,
    private router: Router
  ) {
    effect(() => {
      if (this._stateService.initialized()) {
        const state: any = this._stateService.appState();
        if (state && this.checkRequiredPamater(state)) {
          const isNotSameDate =
            `${this.startDate}-${this.endDate}` !=
            `${state.datePicker.startDate}-${state.datePicker.endDate}`;

          this.startDate = state.datePicker.startDate;
          this.endDate = state.datePicker.endDate;
          if (
            this.brandId != state.brandDetails._id ||
            isNotSameDate ||
            !_.isEqual(this.hierarchyStack, state.hierarchyStack)
          ) {
            this.loading = true; // Start loading
            this.brandDetails = state.brandDetails;
            this.brandId = state.brandDetails._id;
            this.hierarchyStack = state.hierarchyStack;
            if (state.hierarchyStack && state.hierarchyStack.length) {
              this.selected_level = state.hierarchyStack[0].field_id;
              this.selected_value = state.hierarchyStack[0].group_key[0];
            }
            this.suggestionConfig = _.get(
              this.brandDetails,
              'action_management_configuration.huddle.modules.escalations'
            );
            this.suggestionBrandId = _.get(
              this.suggestionConfig,
              'config.brand_id'
            );
            this.actionConfig = _.get(
              this.brandDetails,
              'action_management_configuration.huddle.modules.actions'
            );
            this.actionBrandId = _.get(this.actionConfig, 'config.brand_id');
            this.spotlightConfig = _.get(
              this.brandDetails,
              'action_management_configuration.huddle.modules.spotlights'
            );
            this.spotlightBrandId = _.get(
              this.spotlightConfig,
              'config.brand_id'
            );
            if (this.actionBrandId && this.suggestionBrandId) {
              this.fetchHuddleDetails('action', this.actionBrandId);
              this.fetchHuddleDetails('suggestions', this.suggestionBrandId);
              this.handleTaskData('suggestion', this.suggestionBrandId);
              this.handleTaskData('action', this.actionBrandId);
              this.huddleSpotlight(this.spotlightBrandId);
              //this.checkLoadingState();
              //this.getMeetingList();
            }
          }
        }
      }
    });
  }
  toggleDropdown(index: number): void {
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
  }
  
  selectItem(index: number): void {
    this.isDropdownOpen[index] = false; // Close dropdown on selection
  }
  checkLoadingState(): void {
    const state: any = this._stateService.appState() || {}; 
    const isDateUpdated =
      state.datePicker?.startDate === this.startDate &&
      state.datePicker?.endDate === this.endDate;
    const isDataLoaded =
      this.spotlightTotalFeeds !== undefined &&
      this.actionPlanData !== undefined &&
      this.suggestionData !== undefined;
    const isHuddleCountReady = this.getTotalHuddleCount() !== undefined;
    if (isDataLoaded && isDateUpdated && isHuddleCountReady) {
      this.loading = false;
    } else {
      this.loading = true; // Show loader if data is not ready
    }
  }
  
  updateEllipsisStates() {
    this.commentTexts.forEach((elementRef, index) => {
      const el = elementRef.nativeElement;
      const spotlight = this.spotlightData[index];
      if (el.offsetHeight < el.scrollHeight) {
        spotlight.ellipsisActive = true;
      } else {
        spotlight.ellipsisActive = false;
      }
    });
  }

  suggestionEllipsisStates(): void {
    this.problemTexts.forEach((elRef, i) => {
      const el = elRef.nativeElement;
      const row = this.suggestionData.data[i];
      row.problemEllipsisActive = el.offsetHeight < el.scrollHeight;
    });
  
    this.recommendationTexts.forEach((elRef, i) => {
      const el = elRef.nativeElement;
      const row = this.suggestionData.data[i];
      row.recommendationEllipsisActive = el.offsetHeight < el.scrollHeight;
    });
  }
  
  

  actionPlanEllipsisStates(): void {
    this.actionProblemTexts.forEach((elRef, i) => {
      const el = elRef.nativeElement;
      const row = this.actionPlanData.data[i];
      row.actionProblemEllipsisActive = el.offsetHeight < el.scrollHeight;
    });
  
    this.actionThemeTexts.forEach((elRef, i) => {
      const el = elRef.nativeElement;
      const row = this.actionPlanData.data[i];
      row.actionThemeEllipsisActive = el.offsetHeight < el.scrollHeight;
    });
  }
  

  toggleExpandAction(row: any, type: 'problem' | 'theme'): void {
    const isCurrentlyExpanded =
      type === 'problem' ? row.isActionProblemExpanded : row.isActionThemeExpanded;
  
    // Collapse all
    this.actionPlanData.data.forEach((item: any) => {
      item.isActionProblemExpanded = false;
      item.isActionThemeExpanded = false;
    });
  
    // Expand clicked one (if not already)
    if (type === 'problem') {
      row.isActionProblemExpanded = !isCurrentlyExpanded;
    } else {
      row.isActionThemeExpanded = !isCurrentlyExpanded;
    }
  }
  
  
  
  changeCardView(event: Event, selectedCard: any) {
    event.preventDefault();
  
    const isCurrentlyExpanded = selectedCard.showMore;
  
    // Collapse all cards
    this.spotlightData.forEach(card => {
      card.showMore = false;
    });
  
    // Toggle clicked card (only expand if it wasn't already expanded)
    selectedCard.showMore = !isCurrentlyExpanded;
  
    // Recalculate ellipsis buttons
    setTimeout(() => this.updateEllipsisStates(), 0);
  }
  
  

  toggleExpand(row: any, type: 'problem' | 'recommendation'): void {
    const isCurrentlyExpanded =
      type === 'problem' ? row.isProblemExpanded : row.isRecommendationExpanded;
  
    // Collapse all cells
    this.suggestionData.data.forEach((item: any) => {
      item.isProblemExpanded = false;
      item.isRecommendationExpanded = false;
    });
  
    // Expand the clicked one (only if it wasn’t already expanded)
    if (type === 'problem') {
      row.isProblemExpanded = !isCurrentlyExpanded;
    } else {
      row.isRecommendationExpanded = !isCurrentlyExpanded;
    }
  }
  
  checkRequiredPamater(state: any) {
    if (
      state &&
      _.hasIn(state, 'brandDetails') &&
      !_.isEmpty(state.brandDetails) &&
      _.hasIn(state, 'datePicker') &&
      !_.isEmpty(state.datePicker) &&
      _.hasIn(state, 'hierarchyStack') &&
      !_.isEmpty(state.hierarchyStack)
    ) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit(): void {
    this.viewModes = new Array(this.huddleConfigurations?.length).fill(
      'progress'
    );

    // Get query parameters for project and account IDs
    this.route.queryParams.subscribe((params) => {
      this.huddleBrandId = params['project_id'];
      this.huddleAccountId = params['account_id'];
    });
  }

  setActive(button: string) {
    this.activeButton = button;
  }

  // Method to change the current tab
  tabChangeHandler(tab: string) {
    this.huddleService.setCurrentTab(tab);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: tab },
      queryParamsHandling: 'merge', // keeps other query params
    });
  }

  // Get dots for action or suggestion/action cards
  getDotsForCard(cardType: any = {}) {
    const { type } = cardType;
    return type === 'action' ? this.actionDots : this.suggDots;
  }

  toggleView(mode: string, index: number) {
    if (!mode || (mode !== 'progress' && mode !== 'table')) {
      console.warn('Invalid mode passed:', mode);
      return;
    }
    this.viewModes[index] = mode;
  }

  //all huddle 
  // getMeetingList() {
  //     const params: any = {
  //     branch_code: this.selected_value,
  //     branch_level: this.selected_level,
  //     brand_id: this.brandId,
  //     from: this.startDate,
  //     to: this.endDate,
  //     meeting_id: null,
  //     order: 'desc',
  //     order_by: 'created_date',
  //     limit: '10',
  //     page_number: '1',
  //   };
  
  //   this.huddleService.getMeetingsList(params).subscribe(
  //     (response: any) => {
  //       console.log('Meeting List:', response);
  //       if (
  //         _.get(response, 'data.code') === 0 &&
  //         _.hasIn(response, 'data.meetings') &&
  //         !_.isEmpty(response.data.meetings)
  //       ) {
  //         this.totalMeeting = _.get(response, 'data.meetings_count', 0);
  //         let meetingCount =
  //           typeof this.totalMeeting === 'number' ? this.totalMeeting : _.get(this.totalMeeting, 'value', 0);
  
  //         console.log('Total Meetings:', meetingCount);
  
  //         // Process the meeting list and update UI
  //         //this.meetingList = response.data.meetings;
  //       } else {
  //         console.warn('No meetings found');
  //        // this.meetingList = [];
  //       }
  //     },
  //     (error: any) => {
  //       console.error('Error occurred while trying to fetch meetings', error);
  //     }
  //   );
  // }
  

  // Fetch spotlight data for huddle
  huddleSpotlight(brand_id: string): void {
    this.loading = true; // Start loader before API call
  
    const hierarchy_stack = this.hierarchyStack;
    const reqBody = {
      brand_id: brand_id,
      dimension: 
      'litmus_processed_data.tag_ltms_huddle_manager_email_address_1',
      hierarchy_stack: hierarchy_stack,
      huddle_brand_id: this.huddleBrandId,
      limit: 10,
      pageNumber: 1,
      search_field: null,
      search_text: null,
      sort_order: 'desc',
      from: this.startDate,
      to: this.endDate,
    };
  
    this.huddleService.huddleSpotlight(reqBody).subscribe(
      (response: any) => {
        if (response?.data?.spotlight_feed) {
          this.spotlightTotalFeeds = response.data.spotlight_feed.count;
  
          const counts = response.data.counts;
          this.spotlightData = response.data.spotlight_feed.spotlights.map(
            (spotlight: any) => {
              const source = spotlight._source;
              const managerEmail =
                source.litmus_processed_data
                  .tag_ltms_huddle_manager_email_address_1;
  
              // Find corresponding count using the customerName or a unique identifier
              const countKey =
                Object.keys(counts).find((key) => key.includes(managerEmail)) ||
                null;
              const spotlightCount = countKey ? counts[countKey] : 0; // Get count or default to 0 if not found
  
              return {
                ...source,
                managerEmail:
                  source.litmus_processed_data
                    .tag_ltms_huddle_manager_email_address_1,
                feedbackDate: source.feedback_request_date,
                comments:
                  source.litmus_processed_data[
                    'tag_ltms_huddle_03d0366b-7ff3-4079-8075-fecda8216d89_1'
                  ],
                customerName:
                  source.litmus_processed_data[
                    'tag_ltms_huddle_e4147198-6712e-4ced-b98e-5c41d2d46a9712-111'
                  ],
                meetingName: source.litmus_processed_data.tag_meeting_name,
                count: spotlightCount, // Add the count to each spotlight
              };
            }
          );
          //this.spotlightTotalFeeds = response.data.spotlight_feed.count;
          this.totalHuddleFeeds = this.getTotalHuddleCount();
        }
        
        this.checkLoadingState(); // Set loading to false only after everything is done
      },
      (error) => {
        console.error('Error fetching huddle spotlight data:', error);
        this.checkLoadingState(); // Ensure loader is stopped even in case of error
      }
    );
  }

  fetchHuddleDetails(taskType: string, brandId: string) {
    const config = this.huddleConfigurations.find(
      (config) => config.taskType === taskType
    );

    if (config) {
      const { taskType, doughnutId, legendId, cardIndex } = config;

      const hierarchy_stack = this.hierarchyStack || [];
      const queryParams = {
        account_id: this.huddleAccountId,
        active_task_type: taskType,
        brand_id: brandId,
        custom_filter_list: hierarchy_stack.map(({ field_id, group_key }) => ({
          field: field_id,
          value: group_key[0],
        })),
        hierarchy_filter_details_list: hierarchy_stack,
        data_source: '2',
        date_sort_order: 'desc',
        from: this.startDate,
        limit: '10',
        page_number: '1',
        to: this.endDate,
      };
      this.huddleService.getAllHuddle(queryParams).subscribe(
        (response: any) => {
          const { graph_count_details } = response.data || {};
          const chartCount = _.get(graph_count_details, 'chart_count', []);
          const donutData = _.get(graph_count_details, 'donut_count', []);
          // console.log(response, queryParams,'FETCH')
          const data = donutData.map(({ status, count }) => ({
            key: status,
            value: count,
          }));
          const colors = donutData.map(
            ({ status }) => this.colorMapping[status] || 'black'
          );
          const totalFeeds = _.get(response, 'data.total_feeds', 0);

          if (taskType === 'action') {
            Object.assign(this, {
              actionDonutData: data,
              actionDonutColors: colors,
              actionTotalFeeds: totalFeeds,
            });
            this.setDots('actionDots', donutData);
          } else {
            Object.assign(this, {
              suggDonutData: data,
              suggDonutColors: colors,
              suggTotalFeeds: totalFeeds,
            });
            this.setDots('suggDots', donutData);
          }
          this.totalHuddleFeeds = this.getTotalHuddleCount();

          this.cards[cardIndex] = {
            heading: `Top 5 themes - ${
              taskType === 'action' ? 'Action plans' : 'Suggestions'
            }`,
            subHeading: (taskType === 'action' ? 'View the top action plan themes with graphical and tabular status distribution insights.' : 'View the top suggestion themes with graphical and tabular distribution insights across assigned statuses.'),
            data: this.getProgressBarData(chartCount, taskType),
            type: taskType,
          };
        },
        (error) => {
          console.error(`Error fetching ${taskType} huddle details:`, error);
        }
      );
    }
  }

  getDotColor(array, index) {
    if (!array.length) return 'black';
    return array[index];
  }

  handleTaskData(taskType: 'action' | 'suggestion', brandId: string) {
    this.loading = true; 
    const hierarchy_stack = this.hierarchyStack || [];
    const queryParams: any = {
      shop_id_list: '',
      primary_rating_levels: '',
      universal_filter: '',
      assigned_to_id_list: '',
      followers_id_list: '',
      non_existant_fields: taskType === 'action' ? '' : 'sibling_feed_id_list',
      considered_closed_status: '',
      tat_hours: '',
      actionable_ratings: '',
      age_type: '',
      tat_status_list: '',
      brand_id: brandId,
      custom_filter_list: hierarchy_stack.map(({ field_id, group_key }) => ({
        field: field_id,
        value: group_key[0],
      })),
      hierarchy_filter_details_list: hierarchy_stack,
      data_source: '2',
      date_sort_order: 'desc',
      from: this.startDate,
      limit: '10',
      page_number: '1',
      to: this.endDate,
    };

    // Add additional parameters if taskType is suggestion
    if (taskType === 'suggestion') {
      queryParams.date_filter_type = '2';
      queryParams.include_excluded_feeds = 'false';
      queryParams.search_type =
        'tag_ltms_huddle_suggestions_for_process_imporvement_item_description_1';
    }

    // Call the API
    this.huddleService.getFeedListV3(queryParams).subscribe(
      (response: any) => {
        //console.log(response,"PARAMS",queryParams )
        if (taskType === 'action') {
          this.actionPlanData = {
            heading: 'Action plans',
            data: response.data.feed,
          };
        } else {
          this.suggestionData = {
            heading: 'Suggestions',
            data: response.data.feed,
          };
        }
        this.checkLoadingState();
      },
      (error) => {
        console.error(`Error fetching ${taskType} huddle details:`, error);
        this.checkLoadingState();
      }
    );
  }


  setDots(target, donutData) {
    this[target] = donutData.map((data) => ({
      title: data.status,
      count: data.count,
      color: assignColors[data.status] || 'rgb(0, 0, 0)', // Fallback color
    }));
  }

  convertArrayToObject(array: any[]): { [key: string]: number } {
    const result: { [key: string]: number } = {};

    array.forEach((item) => {
      result[item.key] = item.doc_count;
    });

    return result;
  }
  getProgressBarData(data: any, type: string) {
    return data.map((dataItem) => {
      // Convert status_count array into an object for easy lookup
      const statusCountObject =
        this.convertArrayToObject(dataItem.status_count) || {};

      // Create the distribution dynamically based on `status_count` keys
      const distribution = dataItem.status_count.reduce((acc, ele) => {
        acc[ele.key] = ele.doc_count; // Assign doc_count based on the available keys
        return acc;
      }, {});

      // Construct the progress bar array with dynamic `distribution`
      const progressBar = dataItem.status_count.map((ele) => ({
        width: this.calculatePercentage(ele.doc_count, dataItem.count) + '%',
        color: this.colorMapping[ele.key] || 'rgb(0, 0, 0)', // Fallback color if key not found
        distribution,
      }));

      return {
        title: dataItem.name,
        unit: dataItem.count,
        progressBar,
        ...statusCountObject,
      };
    });
  }

  getTotalHuddleCount(): number {
    const total =
      (this.actionTotalFeeds || 0) +
      (this.suggTotalFeeds || 0) +
      (this.spotlightTotalFeeds || 0);
    return isNaN(total) ? 0 : total;
  }
  // Method to calculate percentage
  calculatePercentage(part, total) {
    if (total === 0) {
      return 0;
    }
    return (part / total) * 100;
  }
}
